import { render, staticRenderFns } from "./ModifyOrder.vue?vue&type=template&id=d2045744&scoped=true&"
import script from "./ModifyOrder.vue?vue&type=script&lang=js&"
export * from "./ModifyOrder.vue?vue&type=script&lang=js&"
import style0 from "./ModifyOrder.vue?vue&type=style&index=0&id=d2045744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2045744",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/vsts/work/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VFlex})
